import React, { useRef } from "react";
import { Divider, Flex, Spin } from "antd";
import classname from "classname";

import DescriptorListItem from "../../../../ConfigurePage/Enrollments/components/DescriptorListItem/DescriptorListItem";
import DescriptorsEmpty from "../../../../ConfigurePage/Enrollments/components/DescriptorsList/DescriptorsEmpty";
import DescriptorHeaderAddon from "../../../../ConfigurePage/Enrollments/components/DescriptorHeaderAddon";
import useHasScroll from "../../../../ConfigurePage/Enrollments/hooks/useHasScroll";
import useInteractionObserver from "../../../../ConfigurePage/Enrollments/hooks/useInteractionObscerver";

import "../../../../ConfigurePage/Enrollments/components/DescriptorsList/DescriptorsList.less";

const AdminDescriptorsList = ({
  descriptors,
  enrollment,
  loading,
  isFiltered,
  onLoadMore,
  hasMore,
  onStatusChange,
  onDescriptorTypeChange,
}) => {
  const listRef = useRef(null);
  const sentinelRef = useRef(null);

  useInteractionObserver(sentinelRef, listRef, (isIntersecting) => {
    if (isIntersecting && hasMore) {
      onLoadMore();
    }
  });

  const hasScroll = useHasScroll(listRef);

  return (
    <div
      className={classname("enrollment-descriptors-list", {
        "has-scroll": hasScroll,
      })}
      ref={listRef}
    >
      {descriptors?.length === 0 && !loading && (
        <DescriptorsEmpty
          service={enrollment?.name?.toLowerCase()}
          isFiltered={isFiltered}
        />
      )}
      {loading && (
        <Flex justify="center" align="center" style={{ height: "200px" }}>
          <Spin size="large" />
        </Flex>
      )}
      {!loading &&
        descriptors?.map((descriptor) => (
          <React.Fragment key={descriptor.id}>
            <DescriptorListItem
              descriptor={descriptor}
              service={enrollment?.name?.toLowerCase()}
              headerAddon={
                <DescriptorHeaderAddon
                  status={descriptor.current_status}
                  descriptorType={descriptor.descriptor_type}
                  onStatusChange={(option) => onStatusChange?.(descriptor, option)}
                  onDescriptorTypeChange={(option) => onDescriptorTypeChange?.(descriptor, option)}
                />
              }
            />
            <Divider />
          </React.Fragment>
        ))}
      {!loading && descriptors?.length > 0 && hasMore && <div ref={sentinelRef} />}
      {hasMore && !loading && (
        <Flex justify="center" align="center" style={{ padding: "12px 0" }}>
          <Spin size="large" />
        </Flex>
      )}
    </div>
  );
};

export default AdminDescriptorsList;
